import gsap from "gsap/all";
export default () => ({
  btnHoverColor: getComputedStyle(document.body).getPropertyValue(
    "--btn-hover"
  ),
  init() {
    const easing = {
      ease: "back.out(3.5)",
      duration: 0.3,
    };
    const timeline = gsap.timeline({
      paused: true,
      defaults: {
        ...easing,
      },
    });
    const underlinePath = this.$el.querySelector(".underline path");
    const pathLength = underlinePath.getTotalLength();
    const curvedLineEnabled = this.$el.getAttribute("data-enable-curved") === "true";
    const inheritHoverColorEnabled = this.$el.getAttribute("data-inherit-hover-color") === "true";
    const text = this.$el.querySelector("span:not(.without-animation)");
    const iconArrowRight = this.$el.querySelector(".icon-arrow-right");
    const iconDownload = this.$el.querySelector(".icon-download");
    // initially set svg path to 0
    gsap.set(underlinePath, { strokeDasharray: pathLength });

    if (iconArrowRight) {
      timeline.add(
        gsap.to(iconArrowRight, {
          color: inheritHoverColorEnabled ? "inherit" : this.btnHoverColor,
          x: 5,
          delay: 0.1,
          ...easing,
        }),
        0
      );
    }

    if (text) {
      timeline.add(
        gsap.to(text, {
          x: 6,
          opacity: 1,
        }),
        0
      );
    }

    if (iconDownload) {
      timeline.add(
        gsap.to(iconDownload, {
          color: this.btnHoverColor,
          y: 5,
          delay: 0.1,
          ...easing,
        }),
        0
      );
    }

    if (curvedLineEnabled) {
      timeline.add(
        gsap.fromTo(
          underlinePath,
          { strokeDashoffset: pathLength },
          {
            opacity: 1,
            strokeDashoffset: 0,
            duration: 0.3,
          }
        ),
        0
      );
    }

    if (window.innerWidth >= 1024) {
      this.$el.parentNode.parentNode.addEventListener("mouseenter", () => {
        timeline.play();
      });
      this.$el.parentNode.parentNode.addEventListener("mouseleave", () => {
        timeline.reverse();
      });
    }
  },
});
